import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const form = useRef()

  const navigate = useNavigate()
  
  useEffect(
    () => {
      let timer1 = setTimeout(() => {
        setLetterClass('text-animate-hover')
      }, 3000);

      // this will clear Timeout
      // when component unmount like in willComponentUnmount
      // and show will not change to true
      return () => {
        clearTimeout(timer1);
      };
    },
    // useEffect will run only one time with empty []
    // if you pass a value to array,
    // like this - [data]
    // than clearTimeout will run every time
    // this value changes (useEffect re-run)
    []
  );
  

  const sendEmail = (e) => {

    e.preventDefault();

    console.log({user_email: e.target.value});

    alert("Message has been sent!");

    emailjs
      .sendForm('service_58e444m', 'template_1mba6qr', form.current, 'Ys8hgtQa0jAEZEPHu')
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );

      navigate("/");
  };

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I am interested in software engineering roles/work - especially on 
            ambitious or large projects. Please contact me below if you have any
            questions or concerns.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input placeholder="Name" type="text" name="user_name" required />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="user_email"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input type="submit" className="flat-button" value="SEND" onClick={sendEmail} />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Daniel Deda
          <br />

          <br />
          NYC <br />
          New York USA <br />
          <br />
          <span>danieldeda165@gmail.com</span>
        </div>
        <div className="map-wrap">
        <MapContainer center={[40.7826, -73.9656]} zoom={13}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={[ 40.7826, -73.9656]}>
            <Popup>This is where Daniel grew up!</Popup>
          </Marker>
          <Marker position={[ 41.8236, 19.9973]}>
            <Popup>This is where Daniel is from: Mirdita district in Albania!</Popup>
          </Marker>
        </MapContainer>
        </div>
      </div>
      <Loader type="cube-transition" />
    </>
  )
}

export default Contact
